import React from 'react';
import { clsx } from 'clsx';

import { Image } from 'ui/Image';
import placeholder1 from 'assets/avatar_placeholder_1.png';

import classes from './Avatar.module.scss';
import type { AvatarProps } from './types';

const fallback: Record<number, string> = {
  1: placeholder1,
  2: placeholder1,
  3: placeholder1,
};

export const Avatar: React.FC<AvatarProps> = ({
  src,
  size = 'md',
  variant = 'circle',
  fallbackId = 1,
}) => {
  const [currentSrc, setCurrentSrc] = React.useState(
    src?.trim() ? src : fallback[fallbackId],
  );
  const [useFallback, setUseFallback] = React.useState(!src?.trim());

  const handleError = () => {
    if (fallback[fallbackId]) {
      setCurrentSrc(fallback[fallbackId]);
      setUseFallback(true);
    }
  };

  React.useEffect(() => {
    if (src?.trim()) {
      setCurrentSrc(src);
      setUseFallback(false);
    } else {
      setCurrentSrc(fallback[fallbackId]);
      setUseFallback(true);
    }
  }, [src, fallbackId]);

  if (useFallback) {
    return (
      <img
        src={fallback[fallbackId]}
        className={clsx(classes.root, {
          [classes[`size-${size}`]]: size,
          [classes[`variant-${variant}`]]: variant,
        })}
        alt=''
      />
    );
  }

  return (
    <Image
      src={currentSrc}
      className={clsx(classes.root, {
        [classes[`size-${size}`]]: size,
        [classes[`variant-${variant}`]]: variant,
      })}
      alt=''
      onError={handleError}
    />
  );
};
